import { ActionPlan, Recommendation, CategoryDelegate } from "../types";

export const normalizeDebriefScheduleId = (id: number | string | null | undefined): number | null => {
  if (id === null || id === undefined) return null;
  return Number(id);
};

export const matchesDebriefSchedule = (actionPlan: ActionPlan, debriefScheduleId: number): boolean => {
  const apDebriefId = normalizeDebriefScheduleId(actionPlan.debrief_schedule_id);
  return apDebriefId === debriefScheduleId && !!actionPlan.recommendation_json;
};

export const filterActionPlansByDebriefSchedule = (
  actionPlans: ActionPlan[],
  debriefScheduleId: number
): Recommendation[] => actionPlans
    .filter((ap) => matchesDebriefSchedule(ap, debriefScheduleId))
    .map((ap) => ({
      ...(ap.recommendation_json as Recommendation),
      recommendation_template_id: ap.recommendation, // Ensure template ID is set from the action plan
      notes: ap.notes, // Include notes from action plan
    }));

export const getActionPlanIdsForDebriefSchedule = (
  actionPlans: ActionPlan[],
  debriefScheduleId: number
): Set<number> => new Set(
    actionPlans
      .filter((ap) => {
        const apDebriefId = normalizeDebriefScheduleId(ap.debrief_schedule_id);
        return apDebriefId === debriefScheduleId;
      })
      .map((ap) => ap.id)
  );

export const findMostCommonDebriefScheduleId = (actionPlans: ActionPlan[]): number | null => {
  const counts = new Map<number, number>();
  
  actionPlans.forEach((ap) => {
    const id = normalizeDebriefScheduleId(ap.debrief_schedule_id);
    if (id !== null) {
      counts.set(id, (counts.get(id) || 0) + 1);
    }
  });
  
  if (counts.size === 0) return null;
  
  return Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1])[0][0];
};

export const validateRecommendations = (
  recommendations: Recommendation[]
): { valid: Recommendation[]; invalid: string[] } => {
  const valid: Recommendation[] = [];
  const invalid: string[] = [];
  
  recommendations.forEach((recommendation) => {
    if (!recommendation.recommendation_template_id) {
      invalid.push(recommendation.title ?? recommendation.task_title ?? 'Unknown');
    } else {
      valid.push(recommendation);
    }
  });
  
  return { valid, invalid };
};

export const findCategoryDelegate = (
  categoryUid: string,
  organizationId: number,
  delegates: CategoryDelegate[]
): number | null => {
  const delegate = delegates.find(
    (d) => d.category_uid === categoryUid && d.organization === organizationId
  );
  return delegate ? delegate.employee : null;
};



